import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'

export default function Delivery() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Delivery" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
        <PageWrapper name={'Delivery'} display={<h1 className="txt-big">Delivery</h1>}>
          <span className="txt-cream txt-shadow">Local delivery and courier-style runs in the Discovery Bay area.</span>
        </PageWrapper>
        <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
          <p>
            Need items moved between hotels, villas, or businesses along the north coast? Contact Reggae Wheels
            through About Us to request a delivery run when capacity allows.
          </p>
        </Container>
        <Footer></Footer>
      </motion.div>
      )
}
